
import React, {useContext} from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

function PrivateRoute ({component: Component, authed, ...rest}) {
    return (
      <Route
        {...rest}
        render={(props) => authed === true
          ? <Component {...props} />
          : <Redirect to={{pathname: '/auth/login', state: {from: props.location}}} />}
      />
    )
  }
  export default PrivateRoute;
